// const API_ENDPOINT = "http://localhost:5000";
// const API_ENDPOINT = "https://leanuptime.duckdns.org";
const API_ENDPOINT = "https://app.sitelyze.io";

export { API_ENDPOINT };
